const work = [
  {
    title: "Recollective Inc.",
    year: "Software Developer | Jan 2026 - Present",
    description:
      "One of five engineers on the founding team building Titan, a full-stack SaaS platform built from the ground up. Shipped 65 pull requests across a Vue/Nuxt frontend and Spring Boot backend, owning features end to end from database schema to UI. Resolved N+1 query patterns via batch fetching, built server-side pagination and filtering, designed a 30-day account deletion flow with JWT session revocation, and contributed reusable filter and sort components promoted into the shared design system.",
  },
  {
    title: "Recollective Inc.",
    year: "Software Developer Co-op | May 2025 - Aug 2025",
    description:
      "Refactored UI components across Vue 3, Vue 2, JSP, and React, reducing bugs by 30%. Built a dynamic accessibility testing script using axe-core and Puppeteer that auto-navigates modals and inputs data, reducing manual QA effort by 80%. Integrated the script into CI/CD for scalable long-term testing.",
  },
  {
    title: "Jostle Corporation",
    year: "UI Developer | Jan 2023 - Dec 2024",
    description:
      "Improved search UX with React, Redux, and GraphQL, reducing UI rendering time by 40%. Refactored GWT modules into modern React components, boosted responsiveness by 22% via custom hooks and optimized rendering strategies, and reviewed 130+ pull requests. Retained as part-time contract after co-op based on domain knowledge and output quality.",
  },
  {
    title: "Mineral Deposit Research Unit, UBC",
    year: "Full Stack Designer and Developer | Aug 2022 - Apr 2023",
    description:
      "Led UX design and implemented a custom WordPress theme and 7+ plugins, increasing researcher engagement by 45% through improved UI and accessibility.",
  },
  {
    title: "Deep Blue Creatives",
    year: "Co-Founder and Web Developer | Jul 2019 - Sep 2020",
    description:
      "Delivered 10+ web apps using WordPress, Next.js, and Express. Led a 4-person team and reduced project timelines by 20%.",
  },
  {
    title: "Freelance Web Designer and Developer",
    year: "2019 - Present",
    description:
      "Assisted other designers during peak seasons. Led a team of 2 other web developers on a large-scale e-commerce website. Completed projects: https://deepbluedigital.com, https://issmt.net, https://subsoutlet.com, https://journeyadviser.com.bd, https://osmosis.deepbluetutorials.com, https://deepbluetutorials.com",
  },
  {
    title: "Hapag-Lloyd (GBX Logistics)",
    year: "Intern at IT Department | 2018",
    description:
      "Worked under supervision in the data science team to interpret data, create statistical diagrams, and find strategic trends from product analytics.",
  },
  {
    title: "Amazon Fulfillment Center",
    year: "Warehouse Associate | 2021 - 2022",
    description:
      "Worked with power tools for the safe loading and unloading of products to and from the production line and properly handled packages and tools while complying with health and safety regulations. Coordinated work processes with process assistants with excellent verbal and written communication skills to fulfill daily goals.",
  },
];

export default work;
